import { Suspense, type ReactNode } from 'react';
import { Box, Dialog, DialogBody, DialogContent, DialogHeader } from '@ff-it/ui';
import { FeaturedIcon } from 'components/Icon';
import { fixedWidth } from './ProductDrawerFrame.css';

export type ProductDrawerFrameContent = {
  title: string;
  subtitle?: ReactNode;
  body: ReactNode;
};

export type ProductDrawerFrameProps = {
  open: boolean;
  onClose: () => void;
  content: ProductDrawerFrameContent | null;
  testId?: string;
};

/** Shared right-side product drawer frame for outlet and price-list contexts. */
export function ProductDrawerFrame({ open, onClose, content, testId }: ProductDrawerFrameProps) {
  return (
    <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && onClose()}>
      {content && (
        <DialogContent testId={testId} right className={fixedWidth} p="0" gap="0" overflow="hidden" initialFocus={-1}>
          <DialogHeader
            px="6"
            py="4"
            borderBottom="subtle"
            title={
              <Box as="span" display="block">
                <Box as="span" display="block">
                  {content.title}
                </Box>
                {content.subtitle !== undefined && (
                  <Box
                    as="span"
                    display="block"
                    mt="0.5"
                    fontSize="xs"
                    lineHeight="sm"
                    fontWeight="regular"
                    color="gray600"
                  >
                    {content.subtitle}
                  </Box>
                )}
              </Box>
            }
          >
            <FeaturedIcon icon="box" ml="auto" />
          </DialogHeader>
          <DialogBody p="6" overflow="auto">
            <Suspense fallback={<Box color="gray600">Loading product form…</Box>}>{content.body}</Suspense>
          </DialogBody>
        </DialogContent>
      )}
    </Dialog>
  );
}
